// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6718) return "static/chunks/6718-41014d6d6ddf973a.js";
	if (chunkId === 7646) return "static/chunks/7646-d71f891dbf677d3b.js";
	if (chunkId === 4239) return "static/chunks/4239-8f76ab320648f7b1.js";
	if (chunkId === 2929) return "static/chunks/2929-8abf02a965e1d63e.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2636":"1d04591bc62abdc3","3466":"6e1761cb9ce96e48","5864":"ce57e00407f68312","7072":"102b9deeba353f84","7831":"542cbba739ac38bd","7883":"c0c1f9f89a6d80f9"}[chunkId] + ".js";
};